/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const PlusIcon = ({ color = 'currentColor', className = null }) => (
    <svg
        className={className}
        width="20"
        height="20"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M25 7V43"
            stroke={color}
            strokeWidth="10"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M43 25L7 25"
            stroke={color}
            strokeWidth="10"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

PlusIcon.propTypes = propTypes;

export default PlusIcon;
